import { ISO_DATETIME_RE, parseApiDate, dayjs } from './chunk-WH2C42V5.js';

// src/internal/util/format.ts
function toDayjs(value) {
  if (value === null || value === void 0 || value === "") return null;
  if (dayjs.isDayjs(value)) return value;
  return parseApiDate(value);
}
var config = {
  locale: "en-US",
  currency: "USD",
  dateFormat: "YYYY-MM-DD",
  dateTimeFormat: "YYYY-MM-DD HH:mm",
  timeFormat: "HH:mm",
  weekdayFormat: "dddd",
  weekdayShortFormat: "dd",
  placeholder: "\u2014"
};
function configureFormatting(overrides) {
  Object.assign(config, overrides);
}
function getFormattingConfig() {
  return { ...config };
}
function formatDate(value) {
  const d = toDayjs(value);
  return d ? d.format(config.dateFormat) : config.placeholder;
}
function formatDateTime(value) {
  const d = toDayjs(value);
  return d ? d.format(config.dateTimeFormat) : config.placeholder;
}
function formatTime(value) {
  const d = toDayjs(value);
  return d ? d.format(config.timeFormat) : config.placeholder;
}
function formatWeekday(value, opts) {
  const d = toDayjs(value);
  if (!d) return config.placeholder;
  return d.format(opts?.short ? config.weekdayShortFormat : config.weekdayFormat);
}
function formatRelative(value) {
  const d = toDayjs(value);
  return d ? d.fromNow() : config.placeholder;
}
function formatCurrency(value, opts) {
  if (value === null || value === void 0) return config.placeholder;
  const decimals = opts?.decimals ?? 0;
  return new Intl.NumberFormat(config.locale, {
    style: "currency",
    currency: opts?.currency ?? config.currency,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
}
function formatNumber(value) {
  if (value === null || value === void 0) return config.placeholder;
  return new Intl.NumberFormat(config.locale).format(value);
}
function pluralize(n, locale, forms) {
  const cat = new Intl.PluralRules(locale).select(n);
  return forms[cat] ?? forms.other;
}
function pluralizeCzech(n, forms) {
  return pluralize(n, "cs", { one: forms[0], few: forms[1], many: forms[2], other: forms[2] });
}
function reviveDates(value) {
  if (value === null || value === void 0) return value;
  if (typeof value === "string") {
    return ISO_DATETIME_RE.test(value) ? parseApiDate(value) : value;
  }
  if (Array.isArray(value)) {
    return value.map((v) => reviveDates(v));
  }
  if (typeof value === "object" && !(value instanceof Date) && !dayjs.isDayjs(value)) {
    const result = {};
    for (const key of Object.keys(value)) {
      result[key] = reviveDates(value[key]);
    }
    return result;
  }
  return value;
}

export { configureFormatting, formatCurrency, formatDate, formatDateTime, formatNumber, formatRelative, formatTime, formatWeekday, getFormattingConfig, pluralize, pluralizeCzech, reviveDates };
//# sourceMappingURL=chunk-SUNYEKTQ.js.map
//# sourceMappingURL=chunk-SUNYEKTQ.js.map